/**
 * @generated SignedSource<<e877fb40b59ff90ddfb015ef5d77dae6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
export type FileUploadAreaSubscription$variables = {
  ids: ReadonlyArray<string>;
};
export type FileUploadAreaSubscription$data = {
  readonly fileUpdate: {
    readonly id: string;
    readonly name: string | null;
    readonly status: FileStatus;
  } | null;
};
export type FileUploadAreaSubscription = {
  response: FileUploadAreaSubscription$data;
  variables: FileUploadAreaSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "concreteType": "File",
    "kind": "LinkedField",
    "name": "fileUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadAreaSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileUploadAreaSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af7c4d47da38ba59e7c36b737f97cd10",
    "id": null,
    "metadata": {},
    "name": "FileUploadAreaSubscription",
    "operationKind": "subscription",
    "text": "subscription FileUploadAreaSubscription(\n  $ids: [ID!]!\n) {\n  fileUpdate(ids: $ids) {\n    id\n    name\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "0af18614a9ff4fe703860b2930302356";

export default node;
